import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { SummaryDealExtendedTct } from '@dealstack/shared/lib/generated';
import { getDealQuery } from '@dealstack/frontend/shared/dataExchange/services/project.service';

interface Options
	extends Omit<
		UseQueryOptions<SummaryDealExtendedTct, unknown, SummaryDealExtendedTct, [string]>,
		'queryKey' | 'queryFn'
	> {
	dealId: string;
}

export const useDeal = (
	options: Options
): UseQueryResult<SummaryDealExtendedTct | undefined, unknown> => {
	const { dealId, ...queryOptions } = options;

	return useQuery({
		queryKey: [formatUnicorn(API_PATHS.DEAL_DEALID_GET, { dealId })],
		queryFn: ({ signal }) =>
			getDealQuery(formatUnicorn(API_PATHS.DEAL_DEALID_GET, { dealId }), signal),
		...queryOptions,
	});
};
